import { render, staticRenderFns } from "./moreInfoModal.pug?vue&type=template&id=fb2335fa&lang=pug&"
import script from "./moreInfoModal.js?vue&type=script&lang=js&"
export * from "./moreInfoModal.js?vue&type=script&lang=js&"
import style0 from "./moreInfoModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2335fa')) {
      api.createRecord('fb2335fa', component.options)
    } else {
      api.reload('fb2335fa', component.options)
    }
    module.hot.accept("./moreInfoModal.pug?vue&type=template&id=fb2335fa&lang=pug&", function () {
      api.rerender('fb2335fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/modules/moreInfoModal/index.vue"
export default component.exports